var theme = {
    storageKey: 'ikson-night-mode',

    init: function () {
        theme.applyFromStorage();
        theme.bindNightModeToggle();
    },

    applyFromStorage: function () {
        theme.applyNightMode(localStorage.getItem(theme.storageKey) === '1');
    },

    applyNightMode: function (isEnabled) {
        $('html, body').toggleClass('night-mode', isEnabled);
        $('.night-mode-trigger').attr('aria-pressed', isEnabled ? 'true' : 'false');
        $('.night-mode-trigger')
            .toggleClass('is-day', isEnabled)
            .attr('aria-label', isEnabled ? 'Switch to day mode' : 'Switch to night mode')
            .attr('title', isEnabled ? 'Switch to day mode' : 'Switch to night mode');
    },

    bindNightModeToggle: function () {
        $('.night-mode-trigger').on('click', function (event) {
            event.preventDefault();
            var isEnabled = !$('body').hasClass('night-mode');

            localStorage.setItem(theme.storageKey, isEnabled ? '1' : '0');
            theme.applyNightMode(isEnabled);
        });
    }
};

$(document).ready(theme.init);
